import { IPromoProduct } from '../../types/product';
import { IPromoPopup } from '../../types/promosPage';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPromoDetailsActionTypes {
  OpenDetails = 'PROMO_DETAILS/OPEN_MODAL',
  CloseDetails = 'PROMO_DETAILS/CLOSE_MODAL',
}

interface IOpenPromoDetailsPayload {
  promo: IPromoPopup;
  product: IPromoProduct;
}

export type TOpenPromoDetails = ITypedReduxAction<EPromoDetailsActionTypes.OpenDetails, IOpenPromoDetailsPayload>;
export type TClosePromoDetails = ITypedReduxAction<EPromoDetailsActionTypes.CloseDetails>;

/**
 * Создает Redux action, который открывает модальное окно с подробной информацией об акции
 *
 * @param {IPromoPopup} payload - информация акции для попапа
 */
export const openPromoDetails = actionGenerator<EPromoDetailsActionTypes.OpenDetails, IOpenPromoDetailsPayload>(
  EPromoDetailsActionTypes.OpenDetails,
);

/**
 * Создает Redux action, который закрывает модальное окно с подробной информацией об акции
 */
export const closePromoDetails = actionGenerator<EPromoDetailsActionTypes.CloseDetails>(
  EPromoDetailsActionTypes.CloseDetails,
);

export type TPromoDetailsActions = TOpenPromoDetails | TClosePromoDetails;
